import Vue from "vue"
import VueRouter from "vue-router"
import HelloWorld from "@/components/HelloWorld.vue"
import Home from "@/components/Home.vue"
import CustomBoxes from "@/components/CustomBoxes.vue";
import FaqView from "@/components/FaqView.vue";
import CustomBags from "@/components/CustomBags.vue";
import About from "@/components/About.vue";
Vue.use(VueRouter)
const router = new VueRouter(
    {
        routes: [
            {path: '/', redirect: '/home'},
            {path: '/home', component: Home},
            {path: '/customBoxes', component: CustomBoxes},
            {path: '/customBags', component: CustomBags},
            {path: '/faq', component: FaqView},
            {path: '/about', component: About},
            {path: '/helloWorld', component: HelloWorld}
        ]
    }
)
export default router